/* eslint-disable */

var utils = function () {};

utils.prototype = {
    handledParse: function (val, errorValue, onError) {
        try {
            return JSON.parse(val);
        } catch (e) {

            if(typeof onError === "function")
                onError();

            return errorValue || null;
        }
    },
    /**
     * Extends objects
     * By default shallow extend with true as the last argument is will do deep extend
     * @return {Object}
     */
    extend: function() {

        var args = Array.prototype.slice.call(arguments),
            newObject, keys, lastArg, cKey,
            isDeep,
            self = this;

        // Ignore calls with no args
        if (args.length === 0)  return {};

        // Check if extend is deep
        lastArg = args[args.length - 1];
        isDeep = (lastArg === true);

        // Remove the last arg if it 'true' or 'false'
        if (typeof lastArg === 'boolean') args.pop();

        function handleObjectItem(item, index) {
            newObject[cKey][index] = (!self.isObject(item)) ? item : self.extend(newObject[cKey][index], item, isDeep);
        }

        // Go through the arguments
        for (var i = 0; i < args.length; i++) {

            // Get object keys
            keys = self.keys(args[i]);

            // Skip Objects with no keys
            if (keys.length === 0) continue;

            // Go through keys
            for (var currentKey in args[i]) {

                // Skip none property keys only for deep extend (Otherwise it will be an endless loop)
                if (isDeep && !args[i].hasOwnProperty(currentKey)) continue;

                newObject = newObject || {};

                // When current argument key is array (Only on deep extend)
                if (self.isArray(args[i][currentKey]) && isDeep) {

                    if (typeof newObject[currentKey] !== 'undefined' && self.isArray(newObject[currentKey])) {

                        cKey = currentKey;
                        self.forEach(args[i][currentKey], handleObjectItem);

                    } else {

                        // When newObject currentKey is not yet defined or is none array we just set it to the copy
                        // of the current key argument array (arguments on the same key better be consistent (no array object mix))
                        newObject[currentKey] = args[i][currentKey].slice();
                    }

                    continue;
                }

                // When current argument key is object but not array (Only on deep extend)
                if (self.isObject(args[i][currentKey]) && isDeep) {

                        newObject[currentKey] = (self.isObject(newObject[currentKey])) ? self.extend(newObject[currentKey], args[i][currentKey], isDeep) : self.extend(args[i][currentKey], isDeep);
                        continue;
                }

                // On shallow extent or on deep extend when args[i][currentKey] is not object or array
                if (args[i][currentKey] !== null && args[i][currentKey] !== undefined) newObject[currentKey] = args[i][currentKey];
            }
        }

        return newObject;
    },

    forEach: function(data, fn, that) {
        that = that || null;
        for (var i = 0, n = data.length; i < n; i++) {
            if (i in data) {
                fn.call(that, data[i], i, data);
            }
        }
    },
    truncate: function(text, maxLength = 30) {
        let shortened = text.substring(0, maxLength + 1);

        if (text.length > maxLength) {
            if (shortened.indexOf(' ') == -1){
                return shortened.substring(0, shortened.length -1).trim() + '...';
            } else {
                return shortened.substr(0, Math.min(shortened.length, shortened.lastIndexOf(' '))).trim() + '...';
            }

        } else {
            return text;
        }
    },

    each: function(object, cb, context) {
        context = context  || null;
        var keys;

        if (!this.isObject(object)) return;

        for (var name in object) {
            if (object.hasOwnProperty(name)) {
                cb.call(context, object[name], name);
            }
        }
    },

    bind: function(fn, context) {
        if (typeof fn !== 'function') {
            return;
        }

        if (fn.bind) {
            return fn.bind(context);
        }

        return function() {
            fn.apply(context, arguments);
        };
    },

    isArray: function(item) {
        return (Object.prototype.toString.call(item) === '[object Array]');
    },

    keys: function(obj) {
        var keys = [];
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) keys.push(key);
        }

        return keys;
    },

    isObject: function(canBeObj) {
        return (typeof canBeObj === "object" && canBeObj !== null);
    }
};

module.exports = utils;



/** WEBPACK FOOTER **
 ** ./assets/js/utils.js
 **/